import React from 'react';
//scss
import './Burger.scss';
//animeJs
import anime from 'animejs';
//react-redux
import { connect } from 'react-redux';
//actions
import { slideMenu } from '../../redux/Nav/Actions/Nav.actions';

class Burger extends React.Component {
  constructor() {
    super();
    this.burgerRef = React.createRef();
  }

  componentDidMount() {
    anime({
      targets: '.styledBurger',
      translateX: -50,
      easing: 'linear',
      duration: 1000,
    });
  }
  handleClick = () => {
    this.props.slideMenu();
  };

  onHoverOn = e => {
    anime({
      targets: `.${e.target.className}`,
      scale: 1.4,
    });
  };

  onHoverOut = e => {
    anime({
      targets: `.${e.target.className}`,
      scale: 1,
    });
  };
  render() {
    return (
      <div
        className="styledBurger"
        onClick={this.handleClick}
        onMouseEnter={e => this.onHoverOn(e)}
        onMouseLeave={e => this.onHoverOut(e)}
      >
        <div
          style={{
            transform: this.props.openSlide ? 'rotate(45deg)' : 'rotate(0)',
            width: this.props.openSlide ? '3.75rem' : '4rem',
            marginLeft: this.props.openSlide ? '1rem' : '0',
            backgroundColor:
              this.props.scroll > 0.88
                ? '#f98664'
                : this.props.scroll > 0.28
                ? '#7370a3'
                : '#f98664',
          }}
        />
        <div
          style={{
            opacity: this.props.openSlide ? '0' : '1',
            transform: this.props.openSlide
              ? 'translateX(0px)'
              : 'translateX(0)',
            marginLeft: this.props.openSlide ? '1.5rem' : '0',
            backgroundColor:
              this.props.scroll > 0.88
                ? '#f98664'
                : this.props.scroll > 0.28
                ? '#7370a3'
                : '#f98664',
          }}
        />
        <div
          style={{
            transform: this.props.openSlide ? 'rotate(-45deg)' : 'rotate(0)',
            width: this.props.openSlide ? '3.75rem' : '4rem',
            marginLeft: this.props.openSlide ? '1rem' : '0',
            backgroundColor:
              this.props.scroll > 0.88
                ? '#f98664'
                : this.props.scroll > 0.28
                ? '#7370a3'
                : '#f98664',
          }}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  slideMenu: () => dispatch(slideMenu()),
});

export default connect(null, mapDispatchToProps)(Burger);
